export const status = {
    archived: 'Archived',
    paused: 'Paused',
    live: 'Live',
    concluded: 'Concluded',
    scheduled: 'Scheduled',
} as const

export const statusMapper = (startDate: Date, endDate: Date, isLive: boolean, isArchived: boolean) => {
    const todayTime = Date.now()
    const startTime = startDate.getTime()
    const endTime = endDate.getTime()
    if (isArchived) {
        return status.archived
    }
    if (isLive && startTime < todayTime && endTime > todayTime) {
        return status.live
    }
    if (isLive && startTime > todayTime) {
        return status.scheduled
    }
    if (todayTime > endTime) {
        return status.concluded
    }
    // Live false and archived false
    return status.paused
}
